const CLIENT_ID =
  import.meta.env.VITE_CLIENT_ID || "fz8EApJapg77dqPjbtGiDjS5ag90Xly6J3qc4icU";
const CLIENT_SECRET =
  import.meta.env.VITE_CLIENT_SECRET ||
  "SPaeaVd3Y4bfXXUz9gvJk6Mjwtz9g5gawPb67KSm0GncmicPmOm7EKBJKWuuGq9uqr9ZS0B2d2qolJFnI3x3dkebICQSnKVUhozIvQrJH6yPnAB7XCd4BNI8fyMKghBw";
const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "http://localhost:8888";

export default { API_BASE_URL, CLIENT_ID, CLIENT_SECRET };
